import { api } from './api';
import type { GnRole } from '../components/gn/GnContext';

export type CueType = 'SOLVE' | 'UNDERSTAND_PROBLEM' | 'EXPLAIN_TOPIC' | 'CHECK_ANSWER' | 'IMAGE_QUESTION';

export interface GnCue {
  type: CueType;
  label: string;
  targetHash: string;
}

/**
 * Ambient cue classification (spec 046 US2, contracts/ai-interaction-contract.md §1).
 * The client sends only the debounced candidate region, never the whole page.
 */
export async function classifyCues(
  role: GnRole,
  courseId: number,
  nodeId: number | null,
  contentText: string,
  contentHash: string,
  options?: { inkImagesBase64?: string[]; pastedImageBase64?: string },
): Promise<GnCue[]> {
  const response = await api.post<{ data: GnCue[] }>(`/api/${role}/gn/cues/classify`, {
    courseId,
    nodeId,
    contentText,
    contentHash,
    inkImagesBase64: options?.inkImagesBase64 ?? [],
    pastedImageBase64: options?.pastedImageBase64 ?? null,
  });
  return response.data.data;
}
